import React, { createContext, useContext, useMemo } from 'react';
var defaultValue = {
    withProgressiveLoading: true
};
/**
 * Context to manage image properties,
 * which is easier than prop drilling.
 */
var ImagesContext = createContext(defaultValue);
var ImagesProvider = function (_a) {
    var children = _a.children, value = _a.value;
    var contextValue = useMemo(function () {
        var _a;
        return ({
            withProgressiveLoading: (_a = value === null || value === void 0 ? void 0 : value.withProgressiveLoading) !== null && _a !== void 0 ? _a : defaultValue.withProgressiveLoading
        });
    }, [value === null || value === void 0 ? void 0 : value.withProgressiveLoading]);
    return (React.createElement(ImagesContext.Provider, { value: contextValue }, children));
};
var useImagesContext = function () { return useContext(ImagesContext); };
export { ImagesContext, ImagesProvider, useImagesContext };
